"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_STATION_TILE_ANALYTICS_ROWS_VISIBILITY = exports.STATION_TRAIN_MEASURE_ROWS_LIMIT = exports.STATION_TRAIN_ANALYTICS_ROWS_LIMIT = exports.DEFAULT_STATION_TILE_ANALYTICS_ROWS_VIEW = exports.CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS = void 0;
exports.normalizeStationTileAnalyticsRowsVisibility = normalizeStationTileAnalyticsRowsVisibility;
exports.splitStationTileAnalyticsRowsView = splitStationTileAnalyticsRowsView;
exports.mergeStationTileAnalyticsRowsOrder = mergeStationTileAnalyticsRowsOrder;
exports.normalizeStationTileAnalyticsRowsView = normalizeStationTileAnalyticsRowsView;
exports.sanitizeStationTileAnalyticsRowsOrder = sanitizeStationTileAnalyticsRowsOrder;
exports.pickStationTileAnalyticsRowIds = pickStationTileAnalyticsRowIds;
exports.CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS = [
    "1",
    "2",
    "11",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
];
exports.DEFAULT_STATION_TILE_ANALYTICS_ROWS_VIEW = "1,2,11,3,4";
exports.STATION_TRAIN_ANALYTICS_ROWS_LIMIT = 5;
exports.STATION_TRAIN_MEASURE_ROWS_LIMIT = 4;
exports.DEFAULT_STATION_TILE_ANALYTICS_ROWS_VISIBILITY = {
    "1": true,
    "2": true,
    "11": true,
    "3": true,
    "4": true,
    "5": false,
    "6": false,
    "7": false,
    "8": false,
    "9": false,
    "10": false,
};
function normalizeStationTileAnalyticsRowsVisibility(visibility) {
    if (!visibility || typeof visibility !== "object") {
        return { ...exports.DEFAULT_STATION_TILE_ANALYTICS_ROWS_VISIBILITY };
    }
    const hasAnyKey = exports.CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS.some(id => Object.prototype.hasOwnProperty.call(visibility, id));
    if (!hasAnyKey) {
        return { ...exports.DEFAULT_STATION_TILE_ANALYTICS_ROWS_VISIBILITY };
    }
    const out = {};
    for (const id of exports.CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS) {
        out[id] = Object.prototype.hasOwnProperty.call(visibility, id)
            ? visibility[id] === true
            : exports.DEFAULT_STATION_TILE_ANALYTICS_ROWS_VISIBILITY[id];
    }
    return out;
}
function splitStationTileAnalyticsRowsView(value) {
    if (Array.isArray(value)) {
        return value.map(String).filter(Boolean);
    }
    if (typeof value !== "string") {
        return [];
    }
    const trimmed = value.trim();
    if (!trimmed) {
        return [];
    }
    return trimmed
        .split(",")
        .map(part => part.trim())
        .filter(Boolean);
}
function mergeStationTileAnalyticsRowsOrder(userTokens, canonicalIds = exports.CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS) {
    const seen = new Set();
    const out = [];
    for (const id of userTokens) {
        if (id && !seen.has(id)) {
            seen.add(id);
            out.push(id);
        }
    }
    for (const id of canonicalIds) {
        if (!seen.has(id)) {
            seen.add(id);
            out.push(id);
        }
    }
    return out;
}
function normalizeStationTileAnalyticsRowsView(value, canonicalIds = exports.CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS) {
    return mergeStationTileAnalyticsRowsOrder(splitStationTileAnalyticsRowsView(value), canonicalIds).join(",");
}
function sanitizeStationTileAnalyticsRowsOrder(value, canonicalIds = exports.CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS) {
    return mergeStationTileAnalyticsRowsOrder(splitStationTileAnalyticsRowsView(value), canonicalIds);
}
function pickStationTileAnalyticsRowIds(value, visibility, limit = exports.STATION_TRAIN_ANALYTICS_ROWS_LIMIT, canonicalIds = exports.CANONICAL_STATION_TILE_ANALYTICS_ROW_IDS) {
    const normalizedVisibility = normalizeStationTileAnalyticsRowsVisibility(visibility);
    return sanitizeStationTileAnalyticsRowsOrder(value, canonicalIds)
        .filter(id => normalizedVisibility[id] === true)
        .slice(0, limit)
        .filter((id) => canonicalIds.includes(id));
}
//# sourceMappingURL=station-tile-analytics.js.map